import { SENTRY_EXTRAS_EXCLUDE as l } from "./constants.js";
import { isPlainObject as g, redact as h, findError as E } from "./redact.js";
const S = (t) => function(e, i, s) {
  if (s < 50 || e.length === 0 || !t.getClient()) {
    i.apply(this, e);
    return;
  }
  const r = g(e[0]) ? e[0] : void 0, c = {};
  if (r)
    for (const [o, n] of Object.entries(r))
      l.has(o) || (c[o] = h(n));
  const a = E(r, e), f = e.find(
    (o) => typeof o == "string"
  );
  t.withScope((o) => {
    Object.keys(c).length > 0 && o.setExtras(c), i.apply(this, e), a ? t.captureException(a) : t.captureMessage(
      f ?? "Error logged without a message",
      "error"
    );
  });
};
export {
  S as createSentryLogMethodHook
};
